import React, { useState } from "react";
import { lunchIcon } from "../shared/lunchModel";
import "./LunchPicker.css";

// Modal shown when checking a student in (or editing) while lunch selection is on.
// Pick an entrée + a drink from big, icon-labeled tiles (kid-friendly). On a new
// check-in, Save marks them present with the choice; in edit mode an extra
// "Mark absent" clears the check-in.
export default function LunchPicker({ studentName, entrees, drinks, initial, editing, onSave, onRemove, onCancel }) {
  const [entree, setEntree] = useState(initial?.entree || "");
  const [drink, setDrink] = useState(initial?.drink || "");

  const Tiles = ({ options, value, onPick, kind }) => (
    <div className="lunch-tiles">
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          className={`lunch-tile${value === opt ? " is-on" : ""}`}
          onClick={() => onPick(value === opt ? "" : opt)}
        >
          {value === opt && <span className="lunch-tile-check" aria-hidden="true">✓</span>}
          <span className="lunch-tile-icon" aria-hidden="true">{lunchIcon(opt, kind)}</span>
          <span className="lunch-tile-label">{opt}</span>
        </button>
      ))}
    </div>
  );

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="lunch-picker" onClick={(e) => e.stopPropagation()}>
        <h2 className="lunch-picker-name">{studentName}</h2>
        <p className="lunch-picker-sub">Pick today's lunch</p>

        <div className="lunch-pick-group">
          <div className="lunch-pick-label">Entrée</div>
          <Tiles options={entrees} value={entree} onPick={setEntree} kind="entree" />
        </div>

        {drinks.length > 0 && (
          <div className="lunch-pick-group">
            <div className="lunch-pick-label">Drink</div>
            <Tiles options={drinks} value={drink} onPick={setDrink} kind="drink" />
          </div>
        )}

        <div className="lunch-picker-actions">
          <button onClick={() => onSave({ entree, drink })} disabled={!entree && !drink}>
            {editing ? "Save" : "Check in"}
          </button>
          {editing && (
            <button className="btn-ghost" onClick={onRemove}>Mark absent</button>
          )}
          <button className="btn-secondary" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
